import { useMutation } from '@apollo/client';
import { useState } from 'react';
var AppListingUnwatchApp = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "AppListingUnwatchApp" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "appKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } }, directives: [] }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "unwatchMarketplaceApp" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "appKey" } } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "success" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "errors" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" }, arguments: [], directives: [] }] } }] } }] } }], loc: { start: 0, end: 470, source: { body: "# If you are making any change here\n# Do thoroughly read our graphql contribution guidelines\n# https://bitbucket.org/atlassian-marketplace/marketplace-frontend/src/master/docs/working-with-graphql.md\n\nmutation AppListingWatchApp($appKey: ID!) {\n  watchMarketplaceApp(id: $appKey) {\n    success\n    errors {\n      message\n    }\n  }\n}\n\nmutation AppListingUnwatchApp($appKey: ID!) {\n  unwatchMarketplaceApp(id: $appKey) {\n    success\n    errors {\n      message\n    }\n  }\n}\n", name: "GraphQL request", locationOffset: { line: 1, column: 1 } } } };
var AppListingWatchApp = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "AppListingWatchApp" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "appKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } }, directives: [] }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "watchMarketplaceApp" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "appKey" } } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "success" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "errors" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" }, arguments: [], directives: [] }] } }] } }] } }], loc: { start: 0, end: 470, source: { body: "# If you are making any change here\n# Do thoroughly read our graphql contribution guidelines\n# https://bitbucket.org/atlassian-marketplace/marketplace-frontend/src/master/docs/working-with-graphql.md\n\nmutation AppListingWatchApp($appKey: ID!) {\n  watchMarketplaceApp(id: $appKey) {\n    success\n    errors {\n      message\n    }\n  }\n}\n\nmutation AppListingUnwatchApp($appKey: ID!) {\n  unwatchMarketplaceApp(id: $appKey) {\n    success\n    errors {\n      message\n    }\n  }\n}\n", name: "GraphQL request", locationOffset: { line: 1, column: 1 } } } };
export const useWatchApp = props => {
  const {
    appKey,
    initialWatchingStatus,
    initialWatcherCount,
    userLoggedIn
  } = props;
  const [watchingStatus, setWatchingStatus] = useState(initialWatchingStatus);
  const [watcherCount, setWatcherCount] = useState(initialWatcherCount);
  const [watchMarketplaceApp] = useMutation(AppListingWatchApp, {
    onCompleted: data => {
      var _data$watchMarketplac;
      if ((_data$watchMarketplac = data.watchMarketplaceApp) !== null && _data$watchMarketplac !== void 0 && _data$watchMarketplac.success) {
        setWatchingStatus(true);
        if (props.onWatchSuccess) {
          props.onWatchSuccess();
        }
        if (initialWatchingStatus) {
          setWatcherCount(initialWatcherCount);
        } else setWatcherCount(initialWatcherCount + 1);
      }
    }
  });
  const [unwatchMarketplaceApp] = useMutation(AppListingUnwatchApp, {
    onCompleted: data => {
      var _data$unwatchMarketpl;
      if ((_data$unwatchMarketpl = data.unwatchMarketplaceApp) !== null && _data$unwatchMarketpl !== void 0 && _data$unwatchMarketpl.success && watcherCount !== 0) {
        setWatchingStatus(false);
        if (props.onUnwatchSuccess) {
          props.onUnwatchSuccess();
        }
        if (initialWatchingStatus) {
          setWatcherCount(initialWatcherCount - 1);
        } else setWatcherCount(initialWatcherCount);
      }
    }
  });
  function handleStopWatching(e) {
    if (userLoggedIn) {
      if (props.onWatchAppToggle) {
        props.onWatchAppToggle(false);
      }
      e.preventDefault();
      unwatchMarketplaceApp({
        variables: {
          appKey
        }
      });
    }
  }
  function handleStartWatching(e) {
    if (userLoggedIn) {
      if (props.onWatchAppToggle) {
        props.onWatchAppToggle(true);
      }
      e.preventDefault();
      watchMarketplaceApp({
        variables: {
          appKey
        }
      });
    }
  }
  return {
    watchingStatus,
    watcherCount,
    handleStopWatching,
    handleStartWatching
  };
};